import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const PURCHASE_PRODUCTS_RESPONSE = 'PURCHASE_PRODUCTS_RESPONSE';

export const PURCHASE_REQUEST = 'PURCHASE_REQUEST';
export const PURCHASE_RESPONSE = 'PURCHASE_RESPONSE';
export const CLEAR_PURCHASES = 'CLEAR_PURCHASES';

export function purchaseProductResponse(products) {
  return {
    type: PURCHASE_PRODUCTS_RESPONSE,
    products,
  };
}

export function purchasesRequest() {
  return {
    type: PURCHASE_REQUEST,
  };
}

export function purchasesResponse(purchases) {
  return {
    type: PURCHASE_RESPONSE,
    purchases,
  };
}

export function fetchProducts() {
  return dispatch => {
    fetch(`${API_URL}/purchases/products`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(json => dispatch(purchaseProductResponse(json)));
  };
}

export function fetchAndOpenPaymentPopup(paymentType, productId) {
  return () => {
    fetch(`${API_URL}/purchases/payments/payletter/payment-url?paymentType=${paymentType}&productId=${productId}`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(paymentUrl => _openPaymentPopup(paymentUrl));
  };
}

export function fetchPurchases(entitlements = []) {
  let promises = [];
  entitlements.map(entitlement => promises.push(_fetchPurchase(entitlement.entitlementId)));
  return Promise.all(promises);
}

function _fetchPurchase(entitlementId) {
  return fetch(`${API_URL}/purchases/current-user/by-entitlement-id/${entitlementId}`, {
    method: 'GET',
    headers: commonHeaders(),
  })
    .then(commonErrorHandler)
    .then(response => response.json());
}

export function fetchAndOpenAutoPaymentPopup(
  paymentType,
  productId,
  password,
  autoPaymentPointInTimeCredit,
  agreeForSmsService
) {
  let headers = commonHeaders();
  headers.password = password;
  return () => {
    fetch(
      `${API_URL}/purchases/payments/payletter/auto-payment-url?paymentType=${paymentType}&productId=${productId}&autoPaymentPointInTimeCredit=${autoPaymentPointInTimeCredit}&agreeForSmsService=${agreeForSmsService}`,
      {
        method: 'GET',
        headers: headers,
      }
    )
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(paymentUrl => _openPaymentPopup(paymentUrl))
      .catch(error => {
        if (error.response.status == 403) {
          alert('비밀번호가 올바르지 않습니다.');
        } else if (error.response.status == 409) {
          alert('이미 자동결제 설정이 되어 있습니다.');
        } else {
          alert('결제정보를 입력하는 과정에서 오류가 발생했습니다.');
        }
      });
  };
}

export function fetchAndOpenAutoPaymentReCertificationPopup() {
  let headers = commonHeaders();
  return () => {
    fetch(`${API_URL}/purchases/payments/payletter/auto-payment/reset-url`, {
      method: 'GET',
      headers: headers,
    })
      .then(response => commonErrorHandler(response))
      .then(response => response.json())
      .then(paymentUrl => _openPaymentPopup(paymentUrl));
  };
}

function _openPaymentPopup(paymentUrl) {
  let form = document.createElement('form');
  form.setAttribute('method', 'POST');
  form.setAttribute('action', paymentUrl.url);
  form.setAttribute('target', 'paymentPopup');

  let input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'clientparam';
  input.value = paymentUrl.clientParam;
  form.appendChild(input);
  window.open('', 'paymentPopup', 'width=500,height=600,scrollbars=no,resize=no');

  document.body.appendChild(form);
  form.submit();
}
